// extracted by mini-css-extract-plugin
export default {"container":"UsersleftMessage_container__kTJ3J","root":"UsersleftMessage_root__-xPAW"};